import { format } from "date-fns";
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  OnDestroy,
} from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { CommonService } from "src/app/services/common.service";
import { CommonMethods } from "src/app/shared/CommonMethods";
import { Subscription } from "rxjs";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageServiceService } from "src/app/services/message-service.service";
import { AttachSession } from "protractor/built/driverProviders";
import { environment } from "src/environments/environment";
import { ActivityService } from "src/app/services/activity.service";
import { CitiesList } from "src/app/models/common-model";
@Component({
  selector: "app-package-enquiry",
  templateUrl: "./package-enquiry.component.html",
  styleUrls: ["./package-enquiry.component.scss"],
})
export class PackageEnquiryComponent implements OnInit, OnDestroy {
  enquiryForm: FormGroup;

  //@Input() formReset: boolean;

  //@Input() callerStatusAutoId: number;
  //@Input() selectedCallStatusId: any;

  //@Output() formSubmit = new EventEmitter<any>();

  selectedAppointmentType = 1;
  selectedHospitalType = 2;
  minDate: Date = new Date();
  yearRange = "";
  leadId;
  isNewUser;
  callType;
  callerStatusAutoId;
  rescheduleDetails = [];
  selectedCallStatusId;
  selectedCallStatusName;
  loadingFlag: boolean = false;
  UHIDDetails;
  PackageEnquiryData: Subscription;
  IsThirdPartyIntegration: any;
  citySub: Subscription;
  cities: CitiesList[];

  constructor(
    private fb: FormBuilder,
    private askApolloService: AskApolloService,
    private messageService: MessageServiceService,
    private callCenterService: CallCenterService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private commonService: CommonService,
    private activityService: ActivityService
  ) {
    let date = new Date();
    this.yearRange = `${date.getFullYear()}:${date.getFullYear() + 10}`;
    this.cities = [];
  }

  ngOnInit() {
    this.IsThirdPartyIntegration = environment.IsThirdPartyIntegration;
    this.initiateForm();
    this.getAppointmentDetails();
    // this.getSubDispositionsData();
    this.getAllCities();
    this.citySub = this.activityService.cities.subscribe((cities) => {
      this.cities = cities;
    });
  }

  ngOnDestroy() {
    this.PackageEnquiryData.unsubscribe();
    this.citySub.unsubscribe();
  }

  getAppointmentDetails() {
    this.PackageEnquiryData =
      this.callCenterService.selectedPackageInquiryDetails.subscribe(
        (value) => {
          this.leadId = value.LeadId;
          this.isNewUser = value.IsNewUser;
          this.callType = value.CallTypeId;
          this.callerStatusAutoId = value.CallerStatusAutoId;
          this.rescheduleDetails = value.RescheduleDetails;
          // this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
          this.selectedCallStatusId = 22;
          this.selectedCallStatusName = value.CallStatus["statusName"];
          this.UHIDDetails = value.UHIDDetails;
          this.enquiryForm.controls["PatientName"].setValue(
            this.UHIDDetails.firstName + " " + this.UHIDDetails.lastName
          );
          if (this.UHIDDetails.phoneNo || this.UHIDDetails.mobileNumber) {
            this.enquiryForm.controls["MobileNumber"].setValue(
              this.isNewUser
                ? this.UHIDDetails.phoneNo
                : this.UHIDDetails.mobileNumber
            );
          }
          this.enquiryForm.controls["Email"].setValue(
            this.isNewUser ? this.UHIDDetails.emailId : ""
          );
        }
      );
    this.getSubDispositionsData();
  }

  citiesData: any[];
  clinicsData: any[];
  getAllCities() {
    this.loadingFlag = true;
    this.askApolloService
      // .getAllCities(apptType, this.selectedHospitalType) // appttype, hospitaltype
      .getAllCities(1, 2) // appttype, hospitaltype
      .subscribe(
        (res) => {
          debugger;
          //console.log('cities: ',res.response.citiesList);
          if (res.response.citiesList.length >= 0) {
            this.citiesData = res.response.citiesList;
          } else {
            this.citiesData = [];
          }
          this.loadingFlag = false;
        },
        (error) => {
          this.loadingFlag = false;
          this.messageService.showErrorMessage(
            "Unable to retrieve cities data from server "
          );
        }
      );
  }
  selectedCity;
  getClinicsOnCityId(cityId) {
    this.clinicsData = [];
    this.enquiryForm.get("Clinics").setValue("");
    // this.enquiryForm.get('AGE').setValue('');
    // this.enquiryForm.get('EDD').setValue('');
    // this.enquiryForm.get('IsPackageExplained').setValue('');
    // this.enquiryForm.get('CustomerQuery').setValue('');
    // this.enquiryForm.get('Anyspecialrequest').setValue('');
    // this.enquiryForm.get('UnitVisitAppointment').setValue('');

    if (cityId) {
      this.loadingFlag = true;
      this.selectedCity = cityId;
      this.askApolloService
        .getClinicsOnCityId(
          this.selectedAppointmentType,
          this.selectedHospitalType,
          cityId
        ) // appttype, hospitaltype, cityid
        .subscribe(
          (res: any) => {
            //console.log("Hospitals:", res);
            if (res) {
              this.clinicsData = res.response.result.hospitalList;
            } else {
              this.clinicsData = [];
            }
            this.loadingFlag = false;
          },
          (error) => {
            this.messageService.showErrorMessage(
              "Unable to retrieve clinics data from server "
            );
            this.loadingFlag = false;
          }
        );
    }
  }

  clinicChange(event) {
    // this.enquiryForm.get('AGE').setValue('');
    // this.enquiryForm.get('EDD').setValue('');
    // this.enquiryForm.get('IsPackageExplained').setValue('');
    // this.enquiryForm.get('CustomerQuery').setValue('');
    // this.enquiryForm.get('Anyspecialrequest').setValue('');
    // this.enquiryForm.get('UnitVisitAppointment').setValue('');
  }

  ngOnChanges() {
    // if (this.formReset) {
    //   if (this.enquiryForm) this.resetForm();
    // }
  }

  initiateForm() {
    this.enquiryForm = this.fb.group({
      PatientName: ["", [Validators.required]],
      MobileNumber: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern("^[0-9]{10}$"),
        ],
      ],
      Email: [
        "",
        [
          Validators.pattern(
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
          ),
        ],
      ],
      City: ["", [Validators.required]],
      Clinics: ["", [Validators.required]],
      PackageType: ["", [Validators.required]],
      AGE: ["", [Validators.required, Validators.min(1), Validators.max(120)]],
      EDD: [""],
      IsPackageExplained: ["", [Validators.required]],
      PaymentMode: ["", [Validators.required]],
      CustomerQuery: [""],
      Anyspecialrequest: [""],
      UnitVisitAppointment: [""],
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.enquiryForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }
  restrictToDigits(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, ""); // Replace any non-digit character
  }

  onSubmit() {
    debugger;

    const controls = this.enquiryForm.controls;
    /** check form */
    if (this.enquiryForm.invalid) {
      Object.keys(controls).forEach((controlName) =>
        controls[controlName].markAsTouched()
      );
      return;
    }

    console.log(this.enquiryForm.value);
    let leadData = JSON.parse(
      localStorage.getItem("CurrentOutBoundCallMobileNumber")
    );

    // let leadData1 = JSON.parse(localStorage.getItem("CurrentInBoundCallDetails"));
    //     debugger;
    //     let payload1 ={
    //       "agentNumber": "8128987151",
    //       "ownerId": "23481",
    //       "leadId": '1',
    //       "CallerNumber": leadData1.patientMobileNumber.replace(/^\+91/, '')
    //     }
    //     this.commonService.callEnd(payload1).subscribe(result=>{
    //       debugger;
    //         if(result !== null)
    //         {
    //           this.messageService.showSuccess('Call ended');
    //         }

    //     })

    // if(leadData !== null && leadData !== undefined)
    // {
    //   let id = leadData.id;
    //console.log(id);
    console.log(leadData);
    var optionsSpeciality = this.clinicsData.filter(
      (clinic) => clinic.id === Number(this.enquiryForm.value.Clinics)
    );
    var clinicNameText =
      optionsSpeciality.length > 0 ? optionsSpeciality[0].name : "";
    debugger;
    let payload = {
      //AutoId: +localStorage.getItem("currentCallerStatusAutoId"),
      AutoId: leadData.leadId,
      //LeadId: leadData.leadId,
      CallStatus: 28,
      CallSubStatus: 34,
      Remarks: this.enquiryForm.value.CustomerQuery,
      PatientName: this.enquiryForm.value.PatientName,
      City: this.enquiryForm.value.City.toString(),
      MobileNumber: this.enquiryForm.value.MobileNumber,
      Email: this.enquiryForm.value.Email,
      PackageType: this.enquiryForm.value.PackageType,
      PaymentMode: this.enquiryForm.value.PaymentMode,
      ClinicId: this.enquiryForm.value.Clinics,
      PatientAge: this.enquiryForm.value.AGE,
      EDD: this.enquiryForm.value.EDD
        ? format(this.enquiryForm.value.EDD, "yyyy-MM-dd")
        : "",
      IsPackageExplained: this.enquiryForm.value.IsPackageExplained,
      CustomerQuery: this.enquiryForm.value.CustomerQuery,
      Anyspecialrequest: this.enquiryForm.value.Anyspecialrequest,
      UnitVisitAppointment: this.enquiryForm.value.UnitVisitAppointment
        ? format(this.enquiryForm.value.UnitVisitAppointment, "yyyy-MM-dd")
        : "",
      IsActivityLead:
        localStorage.getItem("IsActivityLead") == "true" ? true : false,
      CallerNumber: leadData.phoneNo,
      clinicName: clinicNameText,
    };
    console.log("call status", payload.CallStatus);

    this.loadingFlag = true;
    console.log("up", payload);
    this.callCenterService.UpdateCallStatusDetails(payload).subscribe(
      (res: any) => {
        console.log("package details", res);

        this.loadingFlag = false;
        alert("package Enquiry Successfully Added.");
        this.messageService.showSuccess("package Enquiry Successfully Added.");
        this.callCenterService.afterCompleteOperationKnowTheStatus({
          callStatusId: this.selectedCallStatusId,
          //"callStatusName": this.selectedCallStatusName,
          isOperationDone: true,
          statusMessage: "package Enquiry Successfully Added.",
        });
      },
      (error) => {
        this.loadingFlag = false;
        this.messageService.showErrorMessage(
          "Unable to add data, An error occur while adding data."
        );
      }
    );
  }
  //}

  resetForm() {
    this.enquiryForm.reset();
    this.enquiryForm.get("City").setValue("");
    this.enquiryForm.get("Clinics").setValue("");
    this.enquiryForm.get("IsPackageExplained").setValue("");
  }

  subDispositionsData = [];
  getSubDispositionsData() {
    debugger;
    this.commonService
      .FetchAllSubDispositions(28) //package inquiry Id: 28
      .subscribe(
        (res: any) => {
          debugger;
          console.log("subDispositionsData", res);
          this.subDispositionsData = res.response;

          // if (res && res.response && res.response.length > 0) {
          //   this.subDispositionsData = res.response;
          // }
          // else {
          //   this.subDispositionsData = [];
          // }
          this.getAllCities();
        },
        (error) => {
          this.messageService.showErrorMessage(
            "Unable to retrieve sub dispositions data from server "
          );
        }
      );
  }

  getSubDispositionsOnId(event) {
    if (event == 35) {
      this.enquiryForm.get("EDD").enable();
    } else {
      this.enquiryForm.get("EDD").disable();
    }
  }
}
